/**
 * Copyright (c) 2025 itemis AG - All rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 *
 * Contributors:
 * 	robin herrmann - itemis AG
 *
 */

import * as ace from "ace-builds";
import AceLanguageServer from "./ace-lsp-adapter";

export function setSyntaxHighlighting(editor: ace.Ace.Editor | undefined, value: boolean) {
  if (!editor) {
    return;
  }
  const session = editor.getSession();
  if (!session) {
    return;
  }
  try {
    if (value) {
      disableSyntaxHighlighting(session);
    } else {
      enableSyntaxHighlighting(session);
    }
  } catch (e) {
    return;
  }
}

function enableSyntaxHighlighting(session: ace.Ace.EditSession) {
  session.setMode("ace/mode/stext");
}

function disableSyntaxHighlighting(session: ace.Ace.EditSession) {
  session.setMode("");
}
